import React from "react";
import { DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { YesNoAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";
import IncidentLogYesNoAnswerField from "./IncidentLogYesNoAnswerField.tsx";
import IncidentLogDateTimeField from "./IncidentLogDateTimeField.tsx";
import { showsResponseDetails } from "./incidentLogResponseSentVisibility.ts";

export interface IncidentLogResponseSentFieldProps {
    answer?: YesNoAnswer | null;
    date?: Date | null;
    time?: Date | null;
    method?: string;
    onAnswerChange: (answer: YesNoAnswer) => void;
    onDateChange: (date: Date | null) => void;
    onTimeChange: (time: Date | null) => void;
    onMethodChange: (method: string) => void;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogResponseSentField(props: IncidentLogResponseSentFieldProps) {
    const { translateString } = useTranslation();

    return (
        <>
            <IncidentLogYesNoAnswerField
                label={translateString("responseSent")}
                answer={props.answer}
                onChange={props.onAnswerChange}
                disabled={props.disabled}
                errorText={props.errorText}
            />
            {showsResponseDetails(props.answer, props.isPreview) && (
                <>
                    <IncidentLogDateTimeField
                        label={translateString("responseDate")}
                        date={props.date}
                        time={props.time}
                        onDateChange={props.onDateChange}
                        onTimeChange={props.onTimeChange}
                        disabled={props.disabled}
                    />
                    <DotLegalTextField
                        label={translateString("responseMethod")}
                        value={props.method ?? ""}
                        debounce
                        multiline
                        rows={3}
                        onChange={props.onMethodChange}
                        disabled={props.disabled}
                    />
                </>
            )}
        </>
    );
}

export default IncidentLogResponseSentField;
